module.exports = __webpack_public_path__ + "static/media/A7402253.0e8a8f8c.jpg";